import React, { VFC, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import {
  selectBridgeSlice,
  setConvertMaxAmount,
  setConvertMinAmount,
} from '../../../redux/slices/bridgeSlice';
import useAppDispatch from '../../../hooks/useAppDispatch';
import useAppSelector from '../../../hooks/useAppSelector';
import BridgeBackend, {
  ConvertAmountRangeResponse,
} from '../../../services/bridge-backend.service';
import useMaxAmountOfTokens from '../../../hooks/common/useMaxAmountOfTokens';

const DivHeader = styled.div`
  color: #000000;
  background-color: #f5f5f5;
  z-index: 1000;
  height: 50px;
  font-weight: 400;
  font-size: 16px;
  padding-top: 18px;
  text-align: center;
  position: fixed;
  width: 100%;
`;
const AHeader = styled.a`
  color: #0d7fe9;
`;

const ImageHeader = styled.img`
  margin-top: -4px;
`;
// FIXME: 하드코딩되어있는 id값 변경 필요

const Header: VFC = () => {
  const dispatch = useAppDispatch();

  const { fromChainToken, selectedFromChain } =
    useAppSelector(selectBridgeSlice);
  const maxAmountOfTokens = useMaxAmountOfTokens(`KSTA`);

  const loadAmountRange = useCallback(async () => {
    try {
      if (fromChainToken && selectedFromChain) {
        const data: ConvertAmountRangeResponse =
          await BridgeBackend.getCryptoCurrencyWithSymbol(
            fromChainToken.chainSymbol,
            fromChainToken.symbol,
          );
        dispatch(setConvertMaxAmount(data.maxAmount));
        dispatch(setConvertMinAmount(data.minAmount));
      } else {
        dispatch(setConvertMaxAmount(0));
        dispatch(setConvertMinAmount(0));
      }
    } catch (e) {
      console.error(e);
    }
  }, [dispatch, fromChainToken, selectedFromChain]);
  useEffect(() => {
    loadAmountRange();
  }, [loadAmountRange, fromChainToken, selectedFromChain]);

  return (
    <DivHeader>
      Please contact the&nbsp;
      <AHeader
        href="https://help.kstadium.io/"
        target="_blank"
        rel="noreferrer"
      >
        K STADIUM Help Center&nbsp;
        <ImageHeader src="/i-window.svg" alt="go to help center" />
      </AHeader>
      &nbsp;to convert amounts higher than {maxAmountOfTokens}
    </DivHeader>
  );
};

export default Header;
